import {
  ExpandablePanel,
  ExpandablePanelBody,
  ExpandablePanelHeader,
  Typography,
} from "@king-ict/eupisi-ui/components";

export interface RequestExpandablePanelProps {
  children?: any;
  panelTitle?: string;
  headerColor?: "bg-light" | "bg-white";
  iconColor?:
    | "success"
    | "danger"
    | "warning"
    | "primary"
    | "body-color"
    | "noted-2"
    | "light-body-color"
    | "black-color"
    | "background-default";
}

export const RequestExpandablePanel = ({
  children,
  panelTitle,
  headerColor = "bg-light",
  iconColor = "primary",
}: RequestExpandablePanelProps) => {
  return (
    <div className="border m-1">
      <ExpandablePanel clickableHeader={true} className="">
        <ExpandablePanelHeader
          className={`${headerColor} p-1`}
          small
          iconColor={iconColor}
        >
          <Typography
            component="span"
            variant="smallBold"
            className="ml-4 mt-3"
          >
            {panelTitle}
          </Typography>
        </ExpandablePanelHeader>
        <ExpandablePanelBody>{children}</ExpandablePanelBody>
      </ExpandablePanel>
    </div>
  );
};
